module.exports = __webpack_public_path__ + "img/img-1.17bc6caf.jpeg";